export default {
  BEFORE_BEGIN: 'beforebegin',
  AFTER_END: 'afterend',
  BEFORE_END: 'beforeend',
};
